import { render, staticRenderFns } from "./DetailLockAwayWhite.vue?vue&type=template&id=045730a0&scoped=true"
import script from "./DetailLockAwayWhite.vue?vue&type=script&lang=js"
export * from "./DetailLockAwayWhite.vue?vue&type=script&lang=js"
import style0 from "./DetailLockAwayWhite.vue?vue&type=style&index=0&id=045730a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045730a0",
  null
  
)

export default component.exports